import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import styles from './CustomModal.css';

class CustomModal extends Component {
  render() {
    const {
      isShowing,
      title,
      description,
      baseStyle,
      buttonCancelText,
      buttonProceedText,
      onCancel,
      onProceed,
    } = this.props;
    const btnProceedStyle =
      baseStyle === 'danger' ? 'btn btn-danger' : 'btn btn-primary';

    return (
      <Modal show={isShowing}>
        <Modal.Header className={styles[baseStyle]}>
          <Modal.Title className={styles.title}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.description}>{description}</div>
        </Modal.Body>
        <Modal.Footer>
          <div className={styles.footer}>
            <button
              className={classNames('btn btn-default', styles.button)}
              onClick={onCancel}
            >
              {buttonCancelText}
            </button>
            <button
              className={classNames(btnProceedStyle, styles.button)}
              onClick={onProceed}
            >
              {buttonProceedText}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

CustomModal.defaultProps = {
  isShowing: false,
  title: '',
  description: '',
  baseStyle: '',
  buttonCancelText: 'Cancel',
  buttonProceedText: 'Proceed',
  onCancel: () => {},
  onProceed: () => {},
};

export default CustomModal;
